import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, Row } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import { SVGICON } from "../../../constant/theme";
import {
  POST_GetDepartmentDropDownList,
  POST_GetReferenceStandardDetailByID,
  POST_ProductGroupDropDownListByMultipleDepartmentID,
  POST_ReferenceStandardInsert,
  POST_ReferenceStandardUpdate,
} from "../../../helpers/url_helper";
import { post, postFormData } from "../../../helpers/api_helper";
import {
  capitalizeString,
  errorMessage,
  successMessage,
  warningMessage,
} from "../CommonFunctions";

const AddReferenceStandard = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam } = useParams();
  const [referenceStandardDocFile, setReferenceStandardDocFile] =
    useState(null);

  // const [productGroupOptions, setProductGroupOptions] = useState([]);
  // const [departmentOptions, setDepartmentOptions] = useState([]);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const validationSchema = Yup.object().shape({
    ReferenceStandard: Yup.string()
      .trim()
      .required("Reference Standard is required field"),
    //DepartmentID: Yup.string().trim().required("Department is required field"),
    // ProductGroupID: Yup.string()
    //   .trim()
    //   .required("Material Group is required field"),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      ReferenceStandardIDEncrypt: PrimaryIdParam
        ? window.atob(PrimaryIdParam)
        : "",
      ReferenceStandard: "",
      Description: "",
      // ProductGroupID: "",
      // DepartmentID: "",
      ListDepartment: [],
      ListMaterialGroup: [],
      searchDepartment: "",
      searchMaterialGroup: "",
      ReferenceDocFilePath: "",
      ReferenceDocFilePathURL: "",
      IsVerified: true,
      VerificationValidityDate: "",
      VerificationDoneBy: "",
      VerificationDoneByName: "",
      VerificationDateTime: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      ReferenceStandardIDEncrypt,
      //DepartmentID,
      ListDepartment,
      searchDepartment,
      ListMaterialGroup,
      searchMaterialGroup,
      ReferenceDocFilePath,
      ReferenceDocFilePathURL,
      IsVerified,
      VerificationValidityDate,
      VerificationDoneBy,
      VerificationDoneByName,
      VerificationDateTime,
    },
  } = formik;

  const handleValidSubmit = (values) => {
    if (
      values?.ListDepartment?.filter((e) => e.IsSelected == true).length == 0
    ) {
      formik.setFieldError(
        "ListDepartment",
        "Please select atleast one Department..!",
      );
      formik.setFieldTouched("ListDepartment", true);
      return;
    }

    if (
      values?.ListMaterialGroup?.filter((e) => e.IsSelected == true).length == 0
    ) {
      formik.setFieldError(
        "ListMaterialGroup",
        "Please select atleast one Material Group ..!",
      );
      formik.setFieldTouched("ListMaterialGroup", true);
      return;
    }

    setIsLoading(true);
    // let payload = {
    //   ...values,

    //   ProductGroupIDs: Array.from(
    //     values?.ListMaterialGroup?.filter((e) => e.IsSelected == true),
    //     (x) => x.ProductGroupIDEncrypt
    //   ).join(","),
    //   DepartmentIDs: Array.from(
    //     values?.ListDepartment?.filter((e) => e.IsSelected == true),
    //     (x) => x.DepartmentIDEncrypt
    //   ).join(","),
    //   CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
    //   CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
    //     ? AuthUser?.ReferenceIDEncrypt
    //     : "0",
    //   ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
    //     ? AuthUser?.ReferenceIDEncrypt
    //     : "0",
    // };

    let formData = new FormData();

    formData.append(
      "ReferenceStandardIDEncrypt",
      values?.ReferenceStandardIDEncrypt,
    );

    formData.append(
      "ProductGroupIDs",
      Array.from(
        values?.ListMaterialGroup?.filter((e) => e.IsSelected == true),
        (x) => x.ProductGroupIDEncrypt,
      ).join(","),
    );
    formData.append(
      "DepartmentIDs",
      Array.from(
        values?.ListDepartment?.filter((e) => e.IsSelected == true),
        (x) => x.DepartmentIDEncrypt,
      ).join(","),
    );
    formData.append("CompanyIDEncrypt", AuthUser?.CompanyIDEncrypt);
    formData.append("BranchIDEncrypted", AuthUser?.BranchIDEncrypt);
    formData.append(
      "CreatedByEncrypt",
      AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0",
    );
    formData.append(
      "ModifiedByEncrypt",
      AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0",
    );

    formData.append("ReferenceStandard", values?.ReferenceStandard.trim());
    formData.append("Description", values?.Description);

    formData.append("ReferenceDocFilePathURL", values?.ReferenceDocFilePathURL);
    formData.append("ReferenceDocFilePath", referenceStandardDocFile);

    postFormData(
      PrimaryIdParam
        ? POST_ReferenceStandardUpdate
        : POST_ReferenceStandardInsert,
      formData,
    )
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/reference-standard");
          }, 1000);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (PrimaryIdParam) {
      getReferenceStandardDetails();
    } else {
      getDepartmentList();
    }
  }, []);

  const getDepartmentList = async () => {
    setIsLoading(true);
    await post(POST_GetDepartmentDropDownList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "ListDepartment",
            response?.List?.map((item) => ({
              DepartmentIDEncrypt: item.DepartmentIDEncrypted,
              DepartmentName: item.DepartmentName,
              IsSelected: false,
              display: true,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleChangeSearchDepartment = (e) => {
    formik.setFieldValue("searchDepartment", e?.target?.value);
    formik.setFieldValue(
      "ListDepartment",
      ListDepartment?.map((x) => {
        return {
          ...x,
          display: x.DepartmentName?.toLowerCase().includes(
            e?.target?.value?.toLowerCase(),
          )
            ? true
            : false,
        };
      }),
    );
  };

  const handleChangeSearchMaterialGroup = (e) => {
    formik.setFieldValue("searchMaterialGroup", e?.target?.value);
    formik.setFieldValue(
      "ListMaterialGroup",
      ListMaterialGroup?.map((x) => {
        return {
          ...x,
          display: x.ProductGroupName?.toLowerCase().includes(
            e?.target?.value?.toLowerCase(),
          )
            ? true
            : false,
        };
      }),
    );
  };

  // const getDepartmentList = async () => {
  //   setIsLoading(true);
  //   await post(POST_GetDepartmentDropDownList, {
  //     CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
  //   })
  //     .then((response) => {
  //       if (response?.IsSuccess) {
  //         setDepartmentOptions(
  //           response?.List?.map((item) => ({
  //             label: item.DepartmentName,
  //             value: item.DepartmentIDEncrypted,
  //           }))
  //         );

  //         /*select the value when there is only one option while insert only*/
  //         if (response?.List?.length == 1 && !PrimaryIdParam) {
  //           formik.setFieldValue(
  //             "DepartmentID",
  //             response?.List[0].DepartmentIDEncrypted
  //           );
  //         }
  //       }
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoading(false);
  //     });
  // };

  const getReferenceStandardDetails = () => {
    setIsLoading(true);
    post(POST_GetReferenceStandardDetailByID, {
      ReferenceStandardIDEncrypt: window.atob(PrimaryIdParam),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setValues({
            ...response,
            ReferenceStandardIDEncrypt: response?.ReferenceStandardIDEncrypt,
            VerificationValidityDate: response?.VerificationValidityDate,
            VerificationDateTime: response?.VerificationDateTime,
            VerificationDoneByName: response?.VerificationDoneByName,
            //ProductGroupID: response?.ProductGroupIDEncrypt,
            //DepartmentID: response?.DepartmentIDEncrypt,
            ListDepartment: response?.DepartmentList?.map((item) => ({
              ...item,
              display: true,
            })),
            // ListMaterialGroup: response?.ProductGroupList?.map((item) => ({
            //   ...item,
            //   IsSelected: item?.IsSelected,
            //   display: true,
            // })),
          });
        }

        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getMaterialGroupList();
  }, [ListDepartment]);

  const getMaterialGroupList = async () => {
    formik.setFieldValue("ListMaterialGroup", []);
    setIsLoading(true);
    await post(POST_ProductGroupDropDownListByMultipleDepartmentID, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      ReferenceStandardIDEncrypt: ReferenceStandardIDEncrypt,
      DepartmentIDs: Array.from(
        ListDepartment?.filter((e) => e.IsSelected == true),
        (x) => x.DepartmentIDEncrypt,
      ).join(","),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "ListMaterialGroup",
            response?.ProductGroupDropDownList?.map((item) => ({
              ProductGroupIDEncrypt: item.ProductGroupIDEncrypt,
              ProductGroupName: item.ProductGroupName,
              IsSelected: item?.IsSelected,
              display: true,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const uploadReferenceStandardDocFile = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      var pattern = /(doc|docx|pdf)$/;

      var validPdfSize = true;
      var validFileFormat = true;
      // alert(file.type.match(pattern));
      //if (!file.type.match(pattern)) {
      if (
        !file.type.match("pdf") &&
        !file.type.match("doc") &&
        !file.type.match("docx")
      ) {
        validFileFormat = false;
        setReferenceStandardDocFile(null);

        warningMessage("Select valid Doc/PDF file!");
      } else {
        if (Math.round(file.size / 1024 / 1024) > 20) {
          validPdfSize = false;
        }
        // }
      }

      if (validFileFormat && validPdfSize) {
        setReferenceStandardDocFile(file);
      } else {
        e.target.value = [];
        if (!validPdfSize) {
          // swal("", "Doc/Pdf file should not be more than 1 MB!", "warning");
          warningMessage("Doc/Pdf file should not be more than 20 MB!");
          setReferenceStandardDocFile(null);
        }
      }
    }
  };

  // useEffect(() => {
  //   if (DepartmentID) {
  //     getProductGroupDDL(DepartmentID);
  //   } else {
  //     setProductGroupOptions([]);
  //     formik.setFieldValue("ProductGroupID", "");
  //   }
  // }, [DepartmentID]);

  // const getProductGroupDDL = (DepartmentID) => {
  //   setIsLoading(true);
  //   post(POST_ProductGroupDropDownListByDepartmentID, {
  //     CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
  //     DepartmentIDEncrypt: DepartmentID,
  //   })
  //     .then((response) => {
  //       if (response?.IsSuccess) {
  //         setProductGroupOptions(
  //           response?.ProductGroupDropDownList?.map((item) => ({
  //             label: item.ProductGroupName,
  //             value: item.ProductGroupIDEncrypt,
  //           }))
  //         );

  //         /*select the value when there is only one option while insert only*/
  //         if (
  //           response?.ProductGroupDropDownList?.length == 1 &&
  //           !PrimaryIdParam
  //         ) {
  //           formik.setFieldValue(
  //             "ProductGroupID",
  //             response?.ProductGroupDropDownList[0].ProductGroupIDEncrypt
  //           );
  //         }
  //       }
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoading(false);
  //     });
  // };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="table-responsive active-projects style-1 shorting">
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">
                {PrimaryIdParam ? "Edit" : "Add"} Reference Standard
              </h4>
              <div className="d-flex align-items-center">
                {PrimaryIdParam ? (
                  <>
                    <div className="pe-2">
                      {IsVerified ? SVGICON.Verified : SVGICON.Unverified}{" "}
                      {IsVerified ? "Verified" : "Unverified"}
                    </div>
                    <div>
                      {VerificationDoneByName ? (
                        <>
                          {" | "}
                          <span className="fs-12">
                            {VerificationDoneByName} {" - "}
                            {VerificationDateTime}
                          </span>
                        </>
                      ) : (
                        ""
                      )}
                      {VerificationDoneByName && VerificationValidityDate
                        ? " | "
                        : ""}
                      {VerificationValidityDate ? (
                        <span className="fs-12">
                          {IsVerified ? "Expiry" : "Expired"} Date -{" "}
                          {VerificationValidityDate}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>{" "}
          </div>
          <hr className="mt-0 mb-1"></hr>
          <div className="p-2 pt-0">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col lg={4}>
                    <Row>
                      <Col lg={12}>
                        <Field
                          label="Reference Standard"
                          name="ReferenceStandard"
                          placeholder={"Enter Reference Standard"}
                          component={CustomInput}
                          required
                          maxLength={100}
                          autoFocus
                          onChange={(e) => {
                            formik.setFieldValue(
                              "ReferenceStandard",
                              capitalizeString(e?.target?.value),
                            );
                          }}
                        />
                      </Col>
                      <Col lg={12}>
                        <Field
                          label="Description"
                          name="Description"
                          placeholder={"Enter Description"}
                          component={CustomTextArea}
                          rows={5}
                          maxLength={500}
                        />
                      </Col>
                      <Col lg={12}>
                        <div className="d-flex justify-content-between">
                          <label className="mb-1">
                            Reference Standard File{" "}
                          </label>
                          {ReferenceDocFilePath ? (
                            <Link
                              to="#"
                              title="Download"
                              className="fs-14"
                              onClick={() => {
                                window.open(ReferenceDocFilePath, "_blank");
                              }}
                            >
                              {SVGICON.Download}
                            </Link>
                          ) : (
                            ""
                          )}
                        </div>
                        <input
                          type="file"
                          id="fileUpload"
                          className="form-control form-control-sm"
                          accept=".doc,.docx,application/pdf"
                          onChange={uploadReferenceStandardDocFile}
                        />
                        <label htmlFor="fileUpload" name=""></label>
                      </Col>
                    </Row>
                  </Col>

                  <Col lg={4} className="mb-2">
                    <label className="mb-1">
                      Departments <span className="text-danger">*</span>
                    </label>
                    <div className="card mb-0 w-100">
                      <div className="card-header p-0">
                        <input
                          type="text"
                          name="searchDepartment"
                          placeholder={"Search here..."}
                          className="form-control form-control-sm"
                          value={searchDepartment}
                          onChange={handleChangeSearchDepartment}
                          style={{
                            borderBottomLeftRadius: "0",
                            borderBottomRightRadius: "0",
                          }}
                        ></input>
                      </div>
                      <div
                        className="card-body p-0  table-responsive"
                        style={{
                          maxHeight: "250px",
                          overflow: "auto",
                        }}
                      >
                        <table className="table table-hover header-border no-footer">
                          <tbody>
                            {ListDepartment?.filter((x) => x.display == true)
                              ?.length > 0 ? (
                              ListDepartment?.map((item, indx) => (
                                <tr
                                  key={indx}
                                  style={{
                                    display: item.display == true ? "" : "none",
                                  }}
                                >
                                  <td
                                    style={{
                                      textAlign: "center",
                                      padding: "0.5rem",
                                      width: "15%",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id={`chkDepartment${indx}`}
                                      name={`chkDepartment${indx}`}
                                      checked={item.IsSelected}
                                      onChange={(e) => {
                                        formik.setFieldValue(
                                          `ListDepartment[${indx}].IsSelected`,
                                          e.target.checked,
                                        );
                                      }}
                                    />
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                      padding: "0.5rem",
                                      width: "85%",
                                    }}
                                  >
                                    {item.DepartmentName}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={2} style={{ textAlign: "center" }}>
                                  <div>{"No options"}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div>
                      <ErrorMessage
                        name={"ListDepartment"}
                        component="div"
                        className="invalid-feedback animated fadeInUp"
                        style={{ display: "block" }}
                      />{" "}
                    </div>
                  </Col>

                  <Col lg={4} className="mb-2">
                    <label className="mb-1">
                      Material Group <span className="text-danger">*</span>
                    </label>
                    <div className="card mb-0 w-100">
                      <div className="card-header p-0">
                        <input
                          type="text"
                          name="searchMaterialGroup"
                          placeholder={"Search here..."}
                          className="form-control form-control-sm"
                          value={searchMaterialGroup}
                          onChange={handleChangeSearchMaterialGroup}
                          style={{
                            borderBottomLeftRadius: "0",
                            borderBottomRightRadius: "0",
                          }}
                        ></input>
                      </div>
                      <div
                        className="card-body p-0  table-responsive"
                        style={{
                          maxHeight: "250px",
                          overflow: "auto",
                        }}
                      >
                        <table className="table table-hover header-border no-footer">
                          <tbody>
                            {ListMaterialGroup?.filter((x) => x.display == true)
                              ?.length > 0 ? (
                              ListMaterialGroup?.map((item, indx) => (
                                <tr
                                  key={indx}
                                  style={{
                                    display: item.display == true ? "" : "none",
                                  }}
                                >
                                  <td
                                    style={{
                                      textAlign: "center",
                                      padding: "0.5rem",
                                      width: "15%",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id={`chkMaterialGroup${indx}`}
                                      name={`chkMaterialGroup${indx}`}
                                      checked={item.IsSelected}
                                      onChange={(e) => {
                                        formik.setFieldValue(
                                          `ListMaterialGroup[${indx}].IsSelected`,
                                          e.target.checked,
                                        );
                                      }}
                                    />
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                      padding: "0.5rem",
                                      width: "85%",
                                    }}
                                  >
                                    {item.ProductGroupName}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={2} style={{ textAlign: "center" }}>
                                  <div>{"No options"}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div>
                      <ErrorMessage
                        name={"ListMaterialGroup"}
                        component="div"
                        className="invalid-feedback animated fadeInUp"
                        style={{ display: "block" }}
                      />
                    </div>
                  </Col>

                  {/* <Col lg={4}>
                    <Field
                      label="Department"
                      name="DepartmentID"
                      placeholder={"Select Department"}
                      component={CustomSelect}
                      options={departmentOptions}
                      required
                    />
                  </Col> */}

                  {/* <Col lg={4}>
                    <Field
                      label="Material Group"
                      name="ProductGroupID"
                      placeholder={"Select Material Group"}
                      component={CustomSelect}
                      options={productGroupOptions}
                      required
                    />
                  </Col> */}
                </Row>
                <Row>
                  <Col>
                    <label className="mb-1"></label>
                  </Col>
                </Row>
                <hr className="mt-1 mb-2"></hr>
                <button type="submit" className="btn btn-primary btn-sm me-2">
                  <i className="fa-solid fa-floppy-disk"></i> Submit
                </button>
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={(e) => {
                    navigate(-1);
                  }}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </button>
              </Form>
            </FormikProvider>
          </div>
        </Spin>
      </div>
    </div>
  );
};

export default AddReferenceStandard;
